import React from 'react'
import StyledImageGallery from './ImageGallery.style'
import { transformUrl, TRANSFORM } from 'components/FileUploader/fileUploadUtils'
import { isImageType } from 'utils/mediaType'
interface LocationImage {
	_id: string
	url: string
	type: string
	note: string
}

export interface Props {
	className?: string
	locationImages: LocationImage[]
	/** Retained for back-compat; no longer fired from this component (the inline
	 *  delete X was removed). Deletion happens via ImageReviewPopup.onDeleteImage. */
	handleDeleteImage?: Function
	handlePreviewImage: Function
}

const LocationImage = ({
	locationImage,
	handlePreviewImage,
}: {
	locationImage: LocationImage
	handlePreviewImage: Function
}) => {
	return (
		<div
			className={`LocationImage ${
				isImageType(locationImage.type) ? '' : 'LocationImage--video'
			}`.trim()}
		>
			{isImageType(locationImage.type) ? (
				<div>
					<div
						className="LocationImage__img"
						onClick={() => handlePreviewImage(locationImage)}
						style={{
							backgroundImage: `url(${transformUrl(locationImage.url, TRANSFORM.THUMB)})`,
						}}
					/>
					{/* Hover overlay — always shows "Click to preview"; note text appears above when present */}
					<div
						className="absolute inset-0 flex flex-col justify-center items-center bg-black bg-opacity-50 text-white text-lg p-2 text-center rounded-md opacity-0 hover:opacity-100 transition-opacity duration-200"
						onClick={() => handlePreviewImage(locationImage)}
					>
						{locationImage.note && <div>{locationImage.note}</div>}
						<div className="text-xs italic text-gray-200 mt-4">Click to preview</div>
					</div>
				</div>
			) : (
				<video className="LocationImage__video" src={locationImage.url} controls />
			)}
		</div>
	)
}

const ImageGallery = ({
	className = '',
	locationImages,
	handlePreviewImage,
}: Props) => {
	return (
		<StyledImageGallery data-testid="ImageGallery" className={className}>
			<ul>
				{locationImages.map(locationImage => {
					return (
						<li key={locationImage._id}>
							<div className="shadow-xl cursor-pointer hover:scale-105 duration-100">
								<LocationImage
									locationImage={locationImage}
									handlePreviewImage={handlePreviewImage}
								/>
							</div>
						</li>
					)
				})}
			</ul>
		</StyledImageGallery>
	)
}

export default ImageGallery
